import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import BuiltForTheLongHaul from "./sections/BuiltForTheLongHaul";
import IndustrySeals from "./sections/IndustrySeals";
import OurExpertise from "./sections/OurExpertise";
import OurTechnicalProcess from "./sections/OurTechnicalProcess";
import WhatOurClientsSay from "./sections/WhatOurClientsSay";
import StrandedGetImmediateHelp from "./sections/StrandedGetImmediateHelp";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <BuiltForTheLongHaul />
      <IndustrySeals />
      <OurExpertise />
      <OurTechnicalProcess />
      <WhatOurClientsSay />
      <StrandedGetImmediateHelp />
      <Footer />
    </div>;
}